module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Ladder-3d9353d3cd9d022c83d4b6a5652aa55d.svg";